// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2zR_i","tab":"ProcedureTabs_tab__sgnD9"};